'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'user-headset';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f82d';
var svgPathData = 'M80 160C80 80.5 144.5 16 224 16S368 80.5 368 160l0 112-80 0c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l184 0c13.3 0 24-10.7 24-24l0-136C416 54 330-32 224-32S32 54 32 160c0 13.3 10.7 24 24 24s24-10.7 24-24zm256 0c0-61.9-50.1-112-112-112S112 98.1 112 160c0 24.5 7.9 47.2 21.2 65.6 15.5-25 43.2-41.6 74.8-41.6l32 0c30.9 0 58.1 15.9 73.8 40l2.2 0c12.7-18.1 20.1-40.2 20.1-64zM153.1 352C77.4 352 16 413.4 16 489.1 16 501.8 26.2 512 38.9 512l370.3 0c12.6 0 22.9-10.2 22.9-22.9 0-75.7-61.4-137.1-137.1-137.1l-141.7 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserHeadset = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;